import { Space, Typography } from 'antd'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { useIFINotificationsContext } from '../IFINotificationsContext'
import { HelpMessage } from 'utils/constants'
import RecipientsTags from 'components/CIMSTags/common/RecipientsTags'
import CIMSSection from 'components/CIMSSection'
import CIMSCollapse from 'components/CIMSCollapse'
import { IFINotificationEvent, IFIReportType } from '@cims-online/shared'
import NotConfigured from './components/NotConfigured'
import FrequencyFields from './components/FrequencyFields'

const ViewIFINotificationEvent: React.VFC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  const { recipients } = useIFINotificationsContext()
  const { every } = recipients(event)
  const isSummarized = event === IFINotificationEvent.IssueSummarized
  return (
    <Space
      direction="vertical"
      size={isSummarized ? 'large' : undefined}
      style={{ width: '100%' }}
    >
      <CIMSSection
        title={`Every ${event.name} Event`}
        help={HelpMessage.Notifications.Every(event, 'Identified Field Issue')}
      >
        <RecipientsTags
          noRecipientsContent={
            <Typography.Text>
              No Recipients have been configured to receive an email for Every{' '}
              {event.name} event, on every Identified Field Issue
            </Typography.Text>
          }
          recipients={every}
        />
      </CIMSSection>
      {isSummarized ? (
        <FrequencyFields />
      ) : (
        <CIMSSection
          help={HelpMessage.IdentifiedFieldIssues.Notifications.ByIFIType(
            event
          )}
          title="Types"
        >
          <CIMSCollapse
            panels={IFIReportType.values.map((ifiReport) => {
              return {
                key: ifiReport.classType,
                header: {
                  type: 'described',
                  name: ifiReport.type,
                },
                children: (
                  <RecipientsTags
                    noRecipientsContent={
                      <NotConfigured
                        type="Type"
                        classType={ifiReport.classType}
                      />
                    }
                    recipients={every}
                  />
                ),
              }
            })}
          />
        </CIMSSection>
      )}
    </Space>
  )
}

export default ViewIFINotificationEvent
